module.exports = __webpack_public_path__ + "static/media/44621768_2199886953419817_6506949743489318912_o-thumb.8e0bf8b6.jpg";